var myHeaders = new Headers();
myHeaders.append("Authorization", "JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyNjcwOTMsInVzZXJuYW1lIjoic3VwcG9ydEBmbGF3bGVzc3ZhcGVkaXN0cm8uY28udWsiLCJleHAiOjE3MzE2MDY4MzksImVtYWlsIjoic3VwcG9ydEBmbGF3bGVzc3ZhcGVkaXN0cm8uY28udWsifQ.WSptY7xXJ12Sz4QgcoyQeMik1wnUnGaZIVjBL2nvJ-Y");

var requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow'
};

fetch("https://api.pushowl.com/api/v1/merchants/shopify/flawless-convenience-store/campaigns/", requestOptions)
  .then(response => response.json())
  .then(data => {
    // Select the list where notifications will be added
    const notificationsList = document.querySelector(".notifications");

    // Check if there are results
    if (data.results.length > 0) {
      data.results.forEach(notification => {
        // Create a list item
        const listItem = document.createElement("li");

        // Add the bell icon
        const icon = document.createElement("i");
        icon.className = "fa-solid fa-bell";

        // Add the notification text inside a span
        const textSpan = document.createElement("span");
        textSpan.className = "scrolling-text";
        textSpan.textContent = `${notification.title}: ${notification.description}`;

        // Append icon and text to the list item
        listItem.appendChild(icon);
        listItem.appendChild(textSpan);

        // Append the list item to the notifications list
        notificationsList.appendChild(listItem);
      });
    } else {
      // No notifications available
      const noNotifications = document.createElement("li");
      noNotifications.textContent = "No recent notifications.";
      notificationsList.appendChild(noNotifications);
    }
  })
  .catch(error => console.log('Error:', error));
